import { SB } from '@play-co/replicant';
import { tuple } from '../utils/types';

const duoStatus = tuple('pending', 'accepted', 'cancelled', 'declined');

export const petSchema = SB.object({
  species: SB.string(),
  name: SB.string(),
  age: SB.number(),
});
const invitationSchema = SB.object({
  timestamp: SB.number(),
  playerId: SB.string(),
  careItemId: SB.string(),
  pet: petSchema,
  status: SB.tuple(duoStatus),
  message: SB.string().optional(),
  lastReminder: SB.number(),
});

export default {
  duo: SB.object({
    invitations: SB.object({
      sent: SB.array(invitationSchema),
      received: SB.array(invitationSchema),
    }),
    lastViewed: SB.number(),
    lastReceivedInvitation: SB.object({
      timestamp: SB.number(),
      playerId: SB.string(),
      name: SB.string(),
    }),
    lastResponse: SB.object({
      timestamp: SB.number(),
      playerId: SB.string(),
      accepted: SB.boolean(),
      name: SB.string(),
    }).optional(),
    debut: SB.object({
      species: SB.string(),
      rewardClaimed: SB.boolean(),
      careItemId: SB.string(),
      inviterId: SB.string(),
      inviteeId: SB.string(),
    }).optional(),
  }),
  platform: SB.string().optional(),
};
